export default __webpack_public_path__ + "static/media/a011-example11_en.fb7acbf0.png";